import React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Startup from './Startup';

export default props => (
    <Startup>
        <div>
            <NavMenu />
            <Container>
                {props.children}
            </Container>
        </div></Startup>
);




// WEBPACK FOOTER //
// ./src/components/Layout.js